module.exports = "\n\n<section-technologies></section-technologies>"